var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"value":_vm.value,"color":"primary"}},[_vm._v(" "+_vm._s(_vm.value)+"% ")])
}
var staticRenderFns = []

export { render, staticRenderFns }